import { IconButton } from '@mgh-app/component-library';
import { TouchRippleActions } from '@mui/material/ButtonBase/TouchRipple';
import { ReactNode } from 'react';
import {
  alignItems,
  backgroundColor,
  borderColor,
  borderRadius,
  borders,
  borderStyle,
  combineCls,
  display,
  dropShadow,
  fontSize,
  gridTemplateColumns,
  gridTemplateRows,
  height,
  justifyContent,
  lineHeight,
  overflow,
  padding,
  textAlign,
  textColor,
  textOverflow,
  twCls,
  width,
} from 'style';

export interface RoomButtonProps {
  name: string;
  icon?: ReactNode;
  iconUrl?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
  onTouchStart?: React.TouchEventHandler<HTMLButtonElement>;
  touchRippleRef?: React.Ref<TouchRippleActions>;
}

export const RoomButton = ({
  name,
  icon,
  iconUrl,
  onClick,
  ...rest
}: RoomButtonProps): JSX.Element => {
  return (
    <IconButton
      onClick={onClick}
      className={twCls(
        width('w-26'),
        height('h-24'),
        borderStyle('border-solid'),
        borders('border-t'),
        borderColor('border-t-grey-300'),
        borderRadius('rounded-xl'),
        backgroundColor('bg-white', 'hover:bg-white'),
        dropShadow('drop-shadow-home'),
        padding('px-2', 'pb-1', 'pt-2'),
        display('grid'),
        gridTemplateRows('grid-rows-min-fc'),
        gridTemplateColumns('grid-cols-1'),
        alignItems('items-end'),
      )}
      {...rest}
    >
      <div className={twCls(display('flex'), justifyContent('justify-end'))}>
        {iconUrl && <img src={iconUrl} alt={`Room: ${name}`} />}
        {icon && icon}
      </div>
      <div
        className={combineCls(
          twCls(
            textColor('text-grey-900'),
            textAlign('text-left'),
            fontSize('text-base'),
            lineHeight('leading-tight'),
            overflow('overflow-hidden'),
            textOverflow('text-ellipsis'),
          ),
          'text-multiline-ellipsis',
        )}
      >
        <p>{name}</p>
      </div>
    </IconButton>
  );
};
